import { render, staticRenderFns } from "./InspectionPlanDetailStaff.vue?vue&type=template&id=05d0a99f&scoped=true"
import script from "./InspectionPlanDetailStaff.vue?vue&type=script&lang=js"
export * from "./InspectionPlanDetailStaff.vue?vue&type=script&lang=js"
import style0 from "./InspectionPlanDetailStaff.vue?vue&type=style&index=0&id=05d0a99f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0a99f",
  null
  
)

export default component.exports